<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import './assets/theme.less';

export default {
  name: 'App'
};
</script>

<style>
body {
  margin: 0;
}

#app {
  padding: 100px;
}

@media (max-width: 1212px) {
  #app {
    padding-left: 0;
    padding-right: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue